import { KPITargetConfiguration } from 'components/Dashboard/DashboardWidget'
import { BaseController } from 'controllers/BaseController'
import { AnalyticsAPI } from './AnalyticsAPI'
import { IAnalyticsAPI, KPI } from './SalesLeadTimeController'
import _ from 'lodash'

export class ConfigurationController extends BaseController<IAnalyticsAPI> {
  constructor(private partyId) {
    super((onRequestCallback) => new AnalyticsAPI(onRequestCallback))
  }

  public async GetAnalyticsConfigurations() {
    try {
      const configs = await this.api.GetKPIConfigurations(this.partyId)

      const defaultConfigs: KPITargetConfiguration[] = [
        {
          kpi: KPI.responseTime,
          value: 2,
          unit: 'hours',
        },
        {
          kpi: KPI.negotiationTime,
          value: 4,
          unit: 'hours',
        },
        {
          kpi: KPI.salesLeadtime,
          value: 24,
          unit: 'hours',
        },
        {
          kpi: KPI.conversionRate,
          value: 0.75,
          unit: '%',
        },
      ]

      const mergeConfigs = _.merge(
        _.keyBy(defaultConfigs, 'kpi'),
        _.keyBy(configs, 'kpi')
      )
      return _.values(mergeConfigs)
    } catch (err) {
      return this.HandleError(err)
    }
  }
}
